import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export const PrivateRouter = ({ children }) => {
  const location = useLocation();
  const { user, hydrated } = useSelector((state) => state.user);

  // Block decision until auth check completes
  if (!hydrated) {
    return null; // later: small spinner/placeholder
  }

  return user?._id ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};
